var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "webContent flex" }, [
    _c("div", { staticClass: "remind" }, [
      _c("div", { staticClass: "model df hao" }, [
        _c(
          "div",
          {
            staticClass: "modelLi flex",
            class: { cur: _vm.chooseModel == "manualCheck" },
            on: {
              click: function($event) {
                return _vm.tabModel("manualCheck")
              }
            }
          },
          [_vm._v("人工审核")]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "modelLi flex",
            class: { cur: _vm.chooseModel == "answerManager" },
            on: {
              click: function($event) {
                return _vm.tabModel("answerManager")
              }
            }
          },
          [_vm._v("回答与管理")]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "modelLi flex",
            class: { cur: _vm.chooseModel == "archiveManager" },
            on: {
              click: function($event) {
                return _vm.tabModel("archiveManager")
              }
            }
          },
          [_vm._v("归档管理")]
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.chooseModel == "manualCheck",
              expression: "chooseModel=='manualCheck'"
            }
          ],
          staticClass: "list",
          on: { scroll: _vm.listenScroll_manualCheck }
        },
        _vm._l(_vm.manualCheckList, function(v, i) {
          return _c("div", { key: i, staticClass: "li" }, [
            _c("div", { staticClass: "title" }, [
              _vm._v(
                _vm._s(v.title + "【" + _vm.replaceStr(v.categoryName) + "】")
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: v.open,
                    expression: "v.open"
                  }
                ],
                staticClass: "txt",
                domProps: { innerHTML: _vm._s(v.txt) }
              },
              [_vm._v(_vm._s(v.txt))]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "df war" }, [
              _c(
                "div",
                {
                  staticClass: "open",
                  class: { cur: v.open },
                  on: {
                    click: function($event) {
                      return _vm.openLi(i)
                    }
                  }
                },
                [_vm._v(_vm._s(v.open ? "收起" : "展开"))]
              )
            ]),
            _vm._v(" "),
            v.relation.id != ""
              ? _c(
                  "div",
                  {
                    staticClass: "relation ov-d",
                    on: {
                      click: function($event) {
                        return _vm.toDetail({ id: v.relation.id })
                      }
                    }
                  },
                  [_vm._v("原始问题：" + _vm._s(v.relation.title))]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "tool df hao" }, [
              _c("div", { staticClass: "flex" }, [
                _c("em", [_vm._v(_vm._s(v.date))]),
                _vm._v(" · " + _vm._s(v.user) + "（" + _vm._s(v.account) + "）")
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "tool-btn" }, [
              _vm.$h5Power == "teacher" ||
              _vm.$h5Power == "admin" ||
              _vm.$h5Power == "instructor"
                ? _c(
                    "div",
                    {
                      staticClass: "change-btn",
                      on: {
                        click: function($event) {
                          return _vm.changeSection(v)
                        }
                      }
                    },
                    [_vm._v("更改版块")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "checkBtn",
                  on: {
                    click: function($event) {
                      return _vm.openConfirm("check", v.title, v)
                    }
                  }
                },
                [_vm._v("通过")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "checkBtn2",
                  on: {
                    click: function($event) {
                      return _vm.openReject(v.title, v)
                    }
                  }
                },
                [_vm._v("驳回")]
              )
            ])
          ])
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.chooseModel == "answerManager",
              expression: "chooseModel=='answerManager'"
            }
          ],
          staticClass: "list",
          on: { scroll: _vm.listenScroll_answerManager }
        },
        _vm._l(_vm.answerManagerList, function(v, i) {
          return _c("div", { key: i, staticClass: "li2" }, [
            _c("div", { staticClass: "cap df hao jcb" }, [
              v.state == 1
                ? _c("div", { staticClass: "state" }, [_vm._v("状态：超时")])
                : v.state == 2
                ? _c("div", { staticClass: "state2" }, [
                    _vm._v("状态：即将超时")
                  ])
                : v.state == 3
                ? _c("div", { staticClass: "state3" }, [_vm._v("状态：正常")])
                : _vm._e(),
              _vm._v(" "),
              _c("span", { domProps: { innerHTML: _vm._s(v.stateTxt) } }, [
                _vm._v(_vm._s(v.stateTxt))
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "item",
                on: {
                  click: function($event) {
                    return _vm.toDetail(v)
                  }
                }
              },
              [
                _c("div", { staticClass: "title" }, [_vm._v(_vm._s(v.title))]),
                _vm._v(" "),
                _c("div", { staticClass: "flex ov-d question_user" }, [
                  _c("em", [_vm._v(_vm._s(v.date))]),
                  _vm._v(" · "),
                  _c("strong", [
                    _vm._v(_vm._s(v.user) + "（" + _vm._s(v.account) + "）")
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "tool df hao" }, [
                  _c(
                    "div",
                    {
                      staticClass: "topBtn",
                      class: { has: v.type.indexOf("top") >= 0 },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          $event.preventDefault()
                          _vm.openConfirm(
                            "top",
                            v.title,
                            v,
                            v.type.indexOf("top") >= 0
                          )
                        }
                      }
                    },
                    [_vm._v("置顶")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "prizeBtn",
                      class: { has: v.type.indexOf("prize") >= 0 },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          $event.preventDefault()
                          _vm.openConfirm(
                            "prize",
                            v.title,
                            v,
                            v.type.indexOf("prize") >= 0
                          )
                        }
                      }
                    },
                    [_vm._v("加精")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "removeBtn",
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          $event.preventDefault()
                          return _vm.openConfirm("remove", v.title, v)
                        }
                      }
                    },
                    [_vm._v("删除")]
                  )
                ])
              ]
            )
          ])
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.chooseModel == "archiveManager",
              expression: "chooseModel=='archiveManager'"
            }
          ],
          staticClass: "list2",
          on: { scroll: _vm.listenScroll_archiveManager }
        },
        _vm._l(_vm.archiveManagerList, function(v, i) {
          return _c("div", { key: i, staticClass: "li3" }, [
            _c("div", { staticClass: "cap" }, [
              _c("em", [_vm._v(_vm._s(v.creatorName))]),
              _c("i", [_vm._v("|")]),
              _vm._v(
                _vm._s(_vm.returnRetDate(v.createTime)) +
                  " 回答了问题\n\t\t\t\t\t"
              ),
              _c(
                "div",
                {
                  staticClass: "recovery",
                  on: {
                    click: function($event) {
                      return _vm.openConfirm("archive", "", v)
                    }
                  }
                },
                [_vm._v("恢复")]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "item" }, [
              _c("div", { staticClass: "title" }, [
                v.announcement == 1
                  ? _c("i", { staticClass: "rule" })
                  : _vm._e(),
                v.refining == 1 ? _c("i", { staticClass: "prize" }) : _vm._e(),
                v.top == 1 ? _c("i", { staticClass: "top" }) : _vm._e(),
                _vm._v(_vm._s(v.title))
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "txt ov-4d",
                  domProps: { innerHTML: _vm._s(v.txt) }
                },
                [_vm._v(_vm._s(v.txt))]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "end df hao" }, [
                _c(
                  "div",
                  {
                    staticClass: "like",
                    class: { has: v.approval != 0 },
                    on: {
                      click: function($event) {
                        return _vm.likeItem("归档中的问题不可点赞！")
                      }
                    }
                  },
                  [_vm._v(_vm._s(v.approvalTotal))]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "collect",
                    class: { has: v.collection != 0 },
                    on: {
                      click: function($event) {
                        return _vm.collectItem("归档中的问题不可收藏！")
                      }
                    }
                  },
                  [_vm._v(_vm._s(v.collectionTotal))]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "flex" }),
                _vm._v(" "),
                _c("div", { staticClass: "date" }, [
                  _vm._v(_vm._s(_vm.dateTime(v.createTime)))
                ])
              ])
            ])
          ])
        }),
        0
      )
    ]),
    _vm._v(" "),
    _vm.confirm.has
      ? _c("div", { staticClass: "confirm df wao hao" }, [
          _c("div", { staticClass: "confirm-box" }, [
            _vm.confirm.type == "check"
              ? _c("div", { staticClass: "confirm-txt df wao" }, [
                  _vm._v("确认"),
                  _c("em", [_vm._v("通过")]),
                  _vm._v("“"),
                  _c(
                    "div",
                    {
                      staticClass: "ov-d",
                      class: { flex: _vm.confirm.txt.length > 6 }
                    },
                    [_vm._v(_vm._s(_vm.confirm.txt))]
                  ),
                  _vm._v("”该问题审核吗？")
                ])
              : _vm.confirm.type == "top"
              ? _c("div", { staticClass: "confirm-txt df wao" }, [
                  _vm._v("确认对“"),
                  _c(
                    "div",
                    {
                      staticClass: "ov-d",
                      class: { flex: _vm.confirm.txt.length > 6 }
                    },
                    [_vm._v(_vm._s(_vm.confirm.txt))]
                  ),
                  _vm._v("”该问题"),
                  _c("em", [
                    _vm._v(
                      _vm._s(_vm.confirm.state == 2 ? "取消" : "") + "置顶"
                    )
                  ]),
                  _vm._v("操作吗？")
                ])
              : _vm.confirm.type == "prize"
              ? _c("div", { staticClass: "confirm-txt df wao" }, [
                  _vm._v("确认对“"),
                  _c(
                    "div",
                    {
                      staticClass: "ov-d",
                      class: { flex: _vm.confirm.txt.length > 6 }
                    },
                    [_vm._v(_vm._s(_vm.confirm.txt))]
                  ),
                  _vm._v("”该问题"),
                  _c("em", [
                    _vm._v(
                      _vm._s(_vm.confirm.state == 2 ? "取消" : "") + "加精"
                    )
                  ]),
                  _vm._v("操作吗？")
                ])
              : _vm.confirm.type == "remove"
              ? _c("div", { staticClass: "confirm-txt df wao" }, [
                  _vm._v("确认对“"),
                  _c(
                    "div",
                    {
                      staticClass: "ov-d",
                      class: { flex: _vm.confirm.txt.length > 6 }
                    },
                    [_vm._v(_vm._s(_vm.confirm.txt))]
                  ),
                  _vm._v("”该问题"),
                  _c("em", [_vm._v("删除")]),
                  _vm._v("操作吗？")
                ])
              : _vm.confirm.type == "archive"
              ? _c("div", { staticClass: "confirm-txt df wao" }, [
                  _vm._v("确认"),
                  _c("em", [_vm._v("取消归档")]),
                  _vm._v("操作吗？")
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "confirm-end df war hao" }, [
              _vm.confirm.type == "check"
                ? _c(
                    "div",
                    {
                      staticClass: "confirm-btn",
                      on: { click: _vm.resConfirm }
                    },
                    [_vm._v("确定")]
                  )
                : _vm.confirm.type == "top"
                ? _c(
                    "div",
                    {
                      staticClass: "confirm-btn",
                      on: { click: _vm.resConfirm }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.confirm.state == 2 ? "取消" : "确定") +
                          "置顶"
                      )
                    ]
                  )
                : _vm.confirm.type == "prize"
                ? _c(
                    "div",
                    {
                      staticClass: "confirm-btn",
                      on: { click: _vm.resConfirm }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.confirm.state == 2 ? "取消" : "确定") +
                          "加精"
                      )
                    ]
                  )
                : _vm.confirm.type == "remove"
                ? _c(
                    "div",
                    {
                      staticClass: "confirm-btn",
                      on: { click: _vm.resConfirm }
                    },
                    [_vm._v("确定删除")]
                  )
                : _vm.confirm.type == "archive"
                ? _c(
                    "div",
                    {
                      staticClass: "confirm-btn",
                      on: { click: _vm.resConfirm }
                    },
                    [_vm._v("确定")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "confirm-btn", on: { click: _vm.closeConfirm } },
                [_vm._v("取消")]
              )
            ])
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.reject.has
      ? _c("div", { staticClass: "reject df wao hao" }, [
          _c("div", { staticClass: "reject-box" }, [
            _c("div", { staticClass: "reject-txt df" }, [
              _vm._v("确认"),
              _c("em", [_vm._v("驳回")]),
              _vm._v("“"),
              _c("div", { staticClass: "flex ov-d" }, [
                _vm._v(_vm._s(_vm.reject.txt))
              ]),
              _vm._v("”该问题审核吗？")
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "reject-val" },
              [
                _c(
                  "div",
                  { staticClass: "reject-tag" },
                  _vm._l(_vm.reject.tag, function(v, i) {
                    return _c(
                      "div",
                      {
                        key: i,
                        staticClass: "reject-tagItem",
                        on: {
                          click: function($event) {
                            return _vm.chooseRejectTag(v)
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.rejectArr[v]))]
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                _c("reject-textarea", {
                  ref: "rejectTextarea",
                  staticClass: "reject-textarea",
                  attrs: {
                    id: "rejectTextareaObj",
                    "data-empty":
                      _vm.reject.remark.length == 0 &&
                      _vm.reject.tag.length == 0
                        ? "请输入驳回理由"
                        : ""
                  },
                  model: {
                    value: _vm.reject.remark,
                    callback: function($$v) {
                      _vm.$set(_vm.reject, "remark", $$v)
                    },
                    expression: "reject.remark"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "reject-tagCap" }, [
              _vm._v("添加驳回理由")
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "reject-tagList" },
              _vm._l(_vm.rejectArr, function(v, i) {
                return _c(
                  "div",
                  {
                    key: i,
                    staticClass: "reject-tagLi",
                    class: { cur: _vm.reject.tag.indexOf(i) >= 0 },
                    on: {
                      click: function($event) {
                        return _vm.chooseRejectTag(i)
                      }
                    }
                  },
                  [_vm._v(_vm._s(v))]
                )
              }),
              0
            ),
            _vm._v(" "),
            _c("div", { staticClass: "reject-end df war hao" }, [
              _c(
                "div",
                {
                  staticClass: "reject-btn",
                  class: {
                    none:
                      _vm.reject.remark.length == 0 &&
                      _vm.reject.tag.length == 0
                  },
                  on: { click: _vm.resReject }
                },
                [_vm._v("驳回")]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "reject-btn", on: { click: _vm.closeReject } },
                [_vm._v("取消")]
              )
            ])
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.isChangeSec
      ? _c("div", { staticClass: "collectBase" }, [
          _c("div", { staticClass: "collectBase-box" }, [
            _c("div", { staticClass: "collectBase-top" }, [
              _c("div", {
                staticClass: "collectBase-close",
                on: { click: _vm.closeCollectBase }
              })
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "collectBase-list" },
              _vm._l(_vm.sectionList, function(v, i) {
                return _c(
                  "div",
                  {
                    key: i,
                    staticClass: "collectBase-li df cf wao",
                    class: { cur: _vm.choose.indexOf(i) >= 0 },
                    on: {
                      click: function($event) {
                        return _vm.chooseCollectBase(i)
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "collectBase-title" }, [
                      _vm._v(_vm._s(v.name ? _vm.replaceStr(v.name) : ""))
                    ])
                  ]
                )
              }),
              0
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "collectBase-btn",
                on: { click: _vm.resCollectBase }
              },
              [_vm._v("确认")]
            )
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-12e72bd3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12e72bd3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/pages/admin/index/index.vue
// module id = null
// module chunks = 